import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useApi } from '@/utils/axios';
import { REVENDA_ROTAS } from '@/utils/apiRoutes';

export const useListaRevendaStore = defineStore('listaRevendas', () => {
  const data = ref([]);
  const loading = ref(false);
  const error = ref(null);

  // Buscar revendas por região com parâmetros específicos
  const buscarRevendasPorRegiao = async (endereco, filtros = {}) => {
    loading.value = true;
    error.value = null;

    try {
      // Dados mocados de latitude e longitude conforme exemplo
      const params = {
        latitude: endereco.latitude,
        longitude: endereco.longitude,
        rua: endereco.rua,
        bairro: endereco.bairro,
        cidade: endereco.cidade,
        estado: endereco.estado,
        cep: endereco.cep,
        externa: filtros.externa,
        tipo_produto: filtros.tipo_produto,
        marca: filtros.marca,
        ordem: filtros.ordem
      };

      const response = await useApi(REVENDA_ROTAS.BUSCAR_POR_REGIAO).fetch({ params });

      console.log('Resposta completa da API:', response);
      console.log('response.data:', response?.data);

      // A API retorna { status: "success", data: { lista_normal: [...] }, meta: {...} }
      let revendasArray = [];

      if (response?.data) {
        const dataContent = response.data;

        // Usar apenas lista_normal
        if (dataContent.lista_normal && Array.isArray(dataContent.lista_normal)) {
          revendasArray = [...dataContent.lista_normal];
          console.log('Revendas encontradas em lista_normal:', dataContent.lista_normal.length);
        }

        // Fallback: Verificar se data é um array direto
        if (revendasArray.length === 0 && Array.isArray(dataContent)) {
          revendasArray = dataContent;
          console.log('Revendas encontradas como array direto:', revendasArray.length);
        }

        console.log('Total de revendas:', revendasArray.length);
      }

      if (revendasArray && revendasArray.length > 0) {
        console.log('Array de revendas encontrado:', revendasArray);
        data.value = revendasArray;
        return revendasArray;
      } else {
        console.error('Estrutura inesperada da resposta:', response);
        throw new Error('Resposta inválida da API');
      }
    } catch (err) {
      error.value = err.message || 'Erro ao buscar revendas por região';
      console.error('Erro ao buscar revendas por região:', err);
      throw err;
    } finally {
      loading.value = false;
    }
  };

  // Cadastrar endereço sem revendedor
  const cadastrarEnderecoSemRevendedor = async (enderecoData) => {
    loading.value = true;
    error.value = null;

    try {
      // Preparar dados para envio
      const payload = {
        ...enderecoData,
        achou_caro: enderecoData.achou_caro ? 1 : 0
      };

      const response = await useApi(REVENDA_ROTAS.CADASTRAR_ENDERECO_SEM_REVENDEDOR).post(payload);

      return {
        success: true,
        data: response?.data
      };
    } catch (err) {
      error.value = err.message || 'Erro ao cadastrar endereço sem revendedor';
      console.error('Erro ao cadastrar endereço sem revendedor:', err);

      return {
        success: false,
        error: error.value
      };
    } finally {
      loading.value = false;
    }
  };

  return {
    data,
    loading,
    error,
    buscarRevendasPorRegiao,
    cadastrarEnderecoSemRevendedor
  };
});
